/**
 * @generated SignedSource<<33251bdd1352b3c516a298bc9caa3941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompletionPeriodType = "ALL_TIME" | "BEFORE_NEXT_WEEK" | "BEFORE_NOW" | "LAST_30_DAYS" | "LAST_7_DAYS" | "LAST_WEEK" | "THIS_WEEK" | "%future added value";
export type CoachClientResponsesRouteQuery$variables = {
  period?: CompletionPeriodType | null | undefined;
  username: string;
};
export type CoachClientResponsesRouteQuery$data = {
  readonly client: {
    readonly displayName: string | null | undefined;
    readonly username: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ClientResponses_root">;
};
export type CoachClientResponsesRouteQuery = {
  response: CoachClientResponsesRouteQuery$data;
  variables: CoachClientResponsesRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "period"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = {
  "kind": "Variable",
  "name": "period",
  "variableName": "period"
},
v3 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "fromNow"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "counts",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rates",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": (v8/*: any*/),
  "kind": "ScalarField",
  "name": "date",
  "storageKey": "date(format:\"fromNow\")"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "client",
    "variableName": "username"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "COMPLETED_AT_DESC"
  },
  {
    "kind": "Literal",
    "name": "withAnswersOnly",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "withClientForms",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "withMealLogging",
    "value": true
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientResponsesRouteQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ClientResponses_root"
      },
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachClientResponsesRouteQuery",
    "selections": [
      {
        "alias": "client",
        "args": (v4/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v2/*: any*/)
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "responsesSummaries",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isResponsesSummary"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "metricType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "componentTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "question",
                "storageKey": null
              },
              {
                "alias": "fromNow",
                "args": (v8/*: any*/),
                "kind": "ScalarField",
                "name": "lastDate",
                "storageKey": "lastDate(format:\"fromNow\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "yes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "no",
                    "storageKey": null
                  }
                ],
                "type": "BinaryResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "type": "RatingResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "textResponses",
                    "args": null,
                    "concreteType": "TextResponse",
                    "kind": "LinkedField",
                    "name": "responses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TextResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "dateResponses",
                    "args": null,
                    "concreteType": "DateResponse",
                    "kind": "LinkedField",
                    "name": "responses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "format",
                            "value": "MM-DD-YYYY"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "selectedDate",
                        "storageKey": "selectedDate(format:\"MM-DD-YYYY\")"
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "DateResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "numberResponses",
                    "args": null,
                    "concreteType": "NumberResponse",
                    "kind": "LinkedField",
                    "name": "responses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "number",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "NumberResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "emojiResponses",
                    "args": null,
                    "concreteType": "EmojiResponse",
                    "kind": "LinkedField",
                    "name": "responses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emoji",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "EmojiResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "starRatingResponses",
                    "args": null,
                    "concreteType": "StarRatingResponse",
                    "kind": "LinkedField",
                    "name": "responses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "starRating",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "StarRatingResponsesSummary",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "options",
                    "storageKey": null
                  }
                ],
                "type": "MultipleChoiceResponsesSummary",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "activities",
        "args": (v13/*: any*/),
        "concreteType": "ActivityConnection",
        "kind": "LinkedField",
        "name": "activitiesConn",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActivityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coachArchived",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "raw",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(raw:true)"
                  },
                  {
                    "alias": "dateFormatted",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "format",
                        "value": "ddd, MMM DD"
                      },
                      {
                        "kind": "Literal",
                        "name": "utc",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": "date(format:\"ddd, MMM DD\",utc:true)"
                  },
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "kind": "ScalarField",
                    "name": "completedAt",
                    "storageKey": "completedAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "kind": "ScalarField",
                    "name": "submittedAt",
                    "storageKey": "submittedAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "edited",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startWorkout",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endWorkout",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Enrollment",
                    "kind": "LinkedField",
                    "name": "enrollment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Program",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Component",
                    "kind": "LinkedField",
                    "name": "component",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientMetric",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v14/*: any*/)
                            ],
                            "type": "CheckinAnswerFileValue",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityFeedback",
                    "kind": "LinkedField",
                    "name": "feedbacks",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "read",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": "createdAt(format:\"fromNow\")"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkoutExerciseResult",
                    "kind": "LinkedField",
                    "name": "workoutExerciseResults",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientForm",
                    "kind": "LinkedField",
                    "name": "clientForm",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coachReadAnswers",
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "activities",
        "args": (v13/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ClientResponsesActivities_activities",
        "kind": "LinkedHandle",
        "name": "activitiesConn"
      }
    ]
  },
  "params": {
    "cacheID": "33c888f3f6fb2d3cb33bda82df171d42",
    "id": null,
    "metadata": {},
    "name": "CoachClientResponsesRouteQuery",
    "operationKind": "query",
    "text": "query CoachClientResponsesRouteQuery(\n  $username: String!\n  $period: CompletionPeriodType\n) {\n  ...ClientResponses_root_y8ROK\n  client: user(username: $username) {\n    displayName\n    username\n    id\n  }\n}\n\nfragment ActivityResponseCard_activity on Activity {\n  id\n  type\n  date(raw: true)\n  dateFormatted: date(utc: true, format: \"ddd, MMM DD\")\n  completedAt(format: \"fromNow\")\n  submittedAt(format: \"fromNow\")\n  answers\n  edited\n  startWorkout\n  endWorkout\n  enrollment {\n    program {\n      name\n      slug\n      id\n    }\n    id\n  }\n  client {\n    displayName\n    photoURL\n    username\n    id\n  }\n  component {\n    type\n    title\n    slug\n    id\n  }\n  metrics {\n    id\n    type\n    name\n    formattedValue\n    value {\n      __typename\n      ... on CheckinAnswerFileValue {\n        url\n        name\n        type\n      }\n    }\n  }\n  feedbacks {\n    id\n    ...ActivityResponseItem_feedback\n  }\n  workoutExerciseResults {\n    ...ActivityWorkoutResponse_workoutExerciseResult\n    id\n  }\n  clientForm {\n    slug\n    id\n  }\n  coachArchived\n  coachReadAnswers\n  ...FeedbackForm_activity\n  ...ActivityResponseMealsList_activity\n}\n\nfragment ActivityResponseItem_feedback on ActivityFeedback {\n  id\n  author {\n    id\n    role\n    displayName\n    photoURL\n  }\n  content\n  read\n  createdAt(format: \"fromNow\")\n}\n\nfragment ActivityResponseMealsList_activity on Activity {\n  content\n}\n\nfragment ActivityWorkoutResponse_workoutExerciseResult on WorkoutExerciseResult {\n  id\n  value\n}\n\nfragment ClientResponsesActivities_root_42ijek on Root {\n  activities: activitiesConn(client: $username, first: 10, withAnswersOnly: true, withMealLogging: true, withClientForms: true, orderBy: COMPLETED_AT_DESC) {\n    edges {\n      node {\n        id\n        coachArchived\n        ...ActivityResponseCard_activity\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ClientResponsesSummaryCard_summary on ResponsesSummary {\n  __isResponsesSummary: __typename\n  metricType\n  componentTitle\n  question\n  fromNow: lastDate(format: \"fromNow\")\n  count\n  ... on BinaryResponsesSummary {\n    yes\n    no\n  }\n  ... on RatingResponsesSummary {\n    counts\n    rates\n  }\n  ... on TextResponsesSummary {\n    textResponses: responses {\n      text\n      date(format: \"fromNow\")\n    }\n  }\n  ... on DateResponsesSummary {\n    dateResponses: responses {\n      selectedDate(format: \"MM-DD-YYYY\")\n      date(format: \"fromNow\")\n    }\n  }\n  ... on NumberResponsesSummary {\n    numberResponses: responses {\n      number\n      date(format: \"fromNow\")\n    }\n  }\n  ... on EmojiResponsesSummary {\n    emojiResponses: responses {\n      emoji\n      date(format: \"fromNow\")\n    }\n  }\n  ... on StarRatingResponsesSummary {\n    starRatingResponses: responses {\n      starRating\n      date(format: \"fromNow\")\n    }\n  }\n  ... on MultipleChoiceResponsesSummary {\n    counts\n    rates\n    options\n  }\n}\n\nfragment ClientResponses_root_y8ROK on Root {\n  client: user(username: $username) {\n    username\n    displayName\n    createdAt\n    responsesSummaries(period: $period) {\n      __typename\n      ...ClientResponsesSummaryCard_summary\n    }\n    id\n  }\n  ...ClientResponsesActivities_root_42ijek\n}\n\nfragment FeedbackForm_activity on Activity {\n  id\n  client {\n    displayName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "590eea7c1b73e3a250df7031759ac84b";

export default node;
